import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCurrencyRub = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_381_35",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 40,
		height: 40,
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_381_35)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0 0H40V40H0V0Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20 0.5C28.8589 0.5 36.3376 6.40839 38.7119 14.5H1.28809C3.66243 6.40839 11.1411 0.5 20 0.5Z",
				stroke: "#EBEBEB"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0 13.3359H40V40H0V13.3359Z",
				fill: "#0039A6"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0 26.6641H40V40H0V26.6641Z",
				fill: "#D52B1E"
			})
		]
	})]
});
export default SvgCurrencyRub;
